import {AfterViewChecked, ChangeDetectorRef, Component, Injector, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {GenericListDialogComponent} from '../../../../common/dialogs/generic-list-dialog/generic-list-dialog.component';
import {AddAtcDialogComponent} from '../../dialogs/add-atc-dialog/add-atc-dialog.component';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {MasterDrugService} from 'src/app/modules/pbm/services/master-drug.service';
import {MasterDrugAtcDTO, MasterDrugDTO} from 'src/app/modules/pbm/models/MasterDrugDTO';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {KeycloakService} from 'keycloak-angular';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {MatStepper} from '@angular/material/stepper';
import {DrugIngredientDTO} from 'src/app/modules/pbm/models/DrugIngredientDTO';
import {throwError} from 'rxjs';
import {ConfirmationDialogComponent} from '../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {AddIngredientViewComponent} from '../add-ingredient-view/add-ingredient-view.component';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {SharedService} from '../../../../common/services/shared-service';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';

@Component({
  selector: 'app-add-master-drug-view',
  templateUrl: './add-master-drug-view.component.html',
  styleUrls: [
    './add-master-drug-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class AddMasterDrugViewComponent implements OnInit, AfterViewChecked {
  readonly lookupValue = LookupValue;

  drugNameFormControl: FormControl;
  startDateFormControl: FormControl;
  endDateFormControl: FormControl;

  dosageFormFormControl: FormControl;
  routeOfAdminFormControl: FormControl;

  ingredientFormControl: FormControl;
  strengthFormControl: FormControl;
  unitOfMeasureFormControl: FormControl;

  atcCodeFormControl: FormControl;

  generalFormGroup: FormGroup;
  detailFormGroup: FormGroup;
  ingredientsFormGroup: FormGroup;
  atcFormGroup: FormGroup;

  dosageForms: NameValueDTO[];
  unitsOfMeasure: NameValueDTO[];
  allIngredients: NameValueDTO[];
  filteredIngredients: NameValueDTO[] = [];
  allRoutes: NameValueDTO[];
  filteredRoutes: NameValueDTO[] = [];
  allAtcCodes: NameValueDTO[];
  filteredAtcCodes: NameValueDTO[] = [];
  helpInfo: HelpDTO[];

  userFirstLastName = '';
  dateFormat = DateUtil.dateFormat;
  isDialog = false;
  dialogRef = null;
  dialogData;

  editMasterDrug = new MasterDrugDTO();
  isEdit = false;

  @ViewChild('stepper') private masterDrugStepper: MatStepper;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private injector: Injector,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private keycloakService: KeycloakService,
    private lookupService: LookupService,
    private sharedService: SharedService,
    private masterDrugService: MasterDrugService,
    private helpService: HelpService
  ) {
    this.dialogRef = this.injector.get(MatDialogRef, null);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);

    if (this.dialogData != null) {
      this.isDialog = this.dialogData;
    }

    this.drugNameFormControl = new FormControl('');
    this.startDateFormControl = new FormControl('');
    this.endDateFormControl = new FormControl('');

    this.generalFormGroup = this.formBuilder.group({
      drugName: this.drugNameFormControl,
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl
    });

    this.dosageFormFormControl = new FormControl('');
    this.routeOfAdminFormControl = new FormControl('');

    this.detailFormGroup = this.formBuilder.group({
      dosageForm: this.dosageFormFormControl,
      routeOfAdministration: this.routeOfAdminFormControl,
      routes: this.formBuilder.array(
        [],
        [Validators.minLength(1), Validators.maxLength(5)]
      )
    });

    this.ingredientFormControl = new FormControl('');
    this.strengthFormControl = new FormControl('');
    this.unitOfMeasureFormControl = new FormControl('');

    this.ingredientsFormGroup = this.formBuilder.group({
      ingredient: this.ingredientFormControl,
      ingredients: this.formBuilder.array(
        [],
        [Validators.minLength(1)]
      )
    });

    this.atcCodeFormControl = new FormControl('');

    this.atcFormGroup = this.formBuilder.group({
      atcCode: this.atcCodeFormControl,
      atcCodes: this.formBuilder.array(
        [],
        [Validators.minLength(1)]
      )
    });
  }

  get routes() {
    return this.detailFormGroup.get('routes') as FormArray;
  }

  get ingredients() {
    return this.ingredientsFormGroup.get('ingredients') as FormArray;
  }

  get atcCodes() {
    return this.atcFormGroup.get('atcCodes') as FormArray;
  }

  ngOnInit(): void {
    if (!this.isDialog) {
      if (this.route.snapshot.url[1].path === 'edit-master-drug') {
        this.isEdit = true;
        this.route.paramMap.subscribe((params) => {
          this.getMasterDrug(Number(params.get('id')));
        });
      }
    }

    this.getListOfLookupValues(this.lookupValue.DosageForm);
    this.getListOfLookupValues(this.lookupValue.UnitOfMeasure);
    this.getListOfLookupValues(this.lookupValue.Ingredient);
    this.getListOfLookupValues(this.lookupValue.RouteOfAdministration);
    this.getListOfLookupValues(this.lookupValue.Atc);

    this.getHelpInfo('master-drug');

    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  getMasterDrug(masterDrugId: number) {
    this.masterDrugService.getMasterDrug(masterDrugId).subscribe(
      (response) => {
        this.editMasterDrug = response;
        this.populateForms();
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  populateForms() {
    this.drugNameFormControl.setValue(this.editMasterDrug.name);
    this.startDateFormControl.setValue(new Date(this.editMasterDrug.startDate));
    this.endDateFormControl.setValue(new Date(this.editMasterDrug.endDate));
    this.dosageFormFormControl.setValue(this.editMasterDrug.dosageForm.name);

    this.editMasterDrug.routesOfAdmin.forEach((route) => {
      this.routes.push(new FormControl(route.name));
    });
    this.editMasterDrug.ingredients.forEach((ingredient) => {
      this.ingredients.push(
        new FormGroup({
          ingredient: new FormControl(ingredient.name),
          strength: new FormControl(ingredient.strength),
          unitOfMeasure: new FormControl(ingredient.unitOfMeasure.name)
        })
      );
    });
    this.editMasterDrug.atcCodes.forEach((atc) => {
      this.atcCodes.push(
        new FormGroup({
          atcCode: new FormControl(atc.name),
          ingredient: new FormControl(atc.ingredients[0].name),
          level: new FormControl('???')
        })
      );
    });
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.DosageForm) {
          this.dosageForms = response;
        }
        else if (entity === this.lookupValue.UnitOfMeasure) {
          this.unitsOfMeasure = response;
        }
        else if (entity === this.lookupValue.RouteOfAdministration) {
          this.allRoutes = response;
        }
        else if (entity === this.lookupValue.Ingredient) {
          this.allIngredients = response;
        }
        else if (entity === this.lookupValue.Atc) {
          this.allAtcCodes = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  filterRoutes() {
    const filterValue = this.routeOfAdminFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredRoutes = this.allRoutes
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  }

  filterIngredients() {
    const filterValue = this.ingredientFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredIngredients = this.allIngredients
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  }

  filterAtcCodes() {
    const filterValue = this.atcCodeFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredAtcCodes = this.allAtcCodes
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  }

  addRoute() {
    if (this.routes.length < 5) {
      if (
        this.filteredRoutes.find(
          (item) => item.name === this.routeOfAdminFormControl.value
        ) != null
      ) {
        this.routes.push(new FormControl(this.routeOfAdminFormControl.value));
      }
      this.routeOfAdminFormControl.setValue('');
    }
    else {
      this.sharedService.openSnackBar('Only 5 routes allowed', 'Dismiss');
    }

    this.routeOfAdminFormControl.setValue('');
    this.filterRoutes();
  }

  removeRoute(index: number) {
    this.routes.removeAt(index);
  }

  addIngredient() {
    if (
      this.filteredIngredients.find(
        (item) => item.name === this.ingredientFormControl.value
      ) != null
    ) {
      const group = new FormGroup({
        ingredient: new FormControl(this.ingredientFormControl.value),
        strength: new FormControl(''),
        unitOfMeasure: new FormControl('')
      });

      this.ingredients.push(group);
    }

    this.ingredientFormControl.setValue('');
    this.filterIngredients();
  }

  removeIngredient(index: number) {
    this.ingredients.removeAt(index);
  }

  addAtcCode() {
    if (
      this.filteredAtcCodes.find(
        (item) => item.name === this.atcCodeFormControl.value
      ) != null
    ) {
      const group = new FormGroup({
        atcCode: new FormControl(this.atcCodeFormControl.value),
        ingredient: new FormControl(''),
        level: new FormControl('')
      });

      this.atcCodes.push(group);
    }

    this.atcCodeFormControl.setValue('');
    this.filterAtcCodes();
  }

  removeAtcCode(index: number) {
    this.atcCodes.removeAt(index);
  }

  finish() {
    const masterDrugDTO = new MasterDrugDTO();
    try {
      masterDrugDTO.name = this.drugNameFormControl.value;
      masterDrugDTO.dosageForm = this.dosageForms.find(
        (item) => item.name === this.dosageFormFormControl.value
      );
      masterDrugDTO.startDate = this.startDateFormControl.value;
      masterDrugDTO.endDate = this.endDateFormControl.value;

      const newRoutes: NameValueDTO[] = [];
      this.routes.controls.forEach((control) => {
        newRoutes.push({
          value: this.allRoutes.find((item) => item.name === control.value)
            .value,
          name: control.value
        });
      });
      masterDrugDTO.routesOfAdmin = newRoutes;

      const newIngredients: DrugIngredientDTO[] = [];
      this.ingredients.controls.forEach((control) => {
        newIngredients.push({
          ingredientId: this.allIngredients.find(
            (item) => item.name === control.value.ingredient
          ).value,
          name: control.value.ingredient,
          strength: control.value.strength,
          unitOfMeasure: {
            value: this.unitsOfMeasure.find(
              (item) => item.name === control.value.unitOfMeasure
            ).value,
            name: control.value.unitOfMeasure
          }
        });
      });
      masterDrugDTO.ingredients = newIngredients;

      const newAtcCodes: MasterDrugAtcDTO[] = [];
      this.atcCodes.controls.forEach((control) => {
        newAtcCodes.push({
          atcId: this.allAtcCodes.find(
            (item) => item.name === control.value.atcCode
          ).value,
          name: control.value.atcCode,
          ingredients: null // TODO: create service to get this - store read only value here
        });
      });
      masterDrugDTO.atcCodes = newAtcCodes;

      if (this.isEdit) {
        masterDrugDTO.masterDrugId = this.editMasterDrug.masterDrugId;
        masterDrugDTO.updated = new Date();
        masterDrugDTO.updatedBy = this.userFirstLastName;
        masterDrugDTO.created = this.editMasterDrug.created;
        masterDrugDTO.createdBy = this.editMasterDrug.createdBy;
      }
      else {
        masterDrugDTO.created = new Date();
        masterDrugDTO.createdBy = this.userFirstLastName;
      }

      this.masterDrugService.saveMasterDrug(masterDrugDTO).subscribe(
        (response) => {
          this.sharedService.openSnackBar(
            `Master drug ${response.name} saved successfully`,
            'Dismiss'
          );
          if (this.isDialog) {
            this.dialogRef.close();
          }
          else {
            this.router.navigate(['/pharmacy-management'], {queryParams: {tab: 'master-drugs'}});
          }
        },
        (error) => {
          throwError(error);
        }
      );
    } catch (e) {
      this.sharedService.openErrorDialog((e as Error).message);
      this.masterDrugStepper.selectedIndex = 0;
    }
  }

  openDialog(displayHeading: string): void {
    const displayList: string[] = [];

    if (displayHeading === 'Ingredients(s)') {
      displayList.push('Ingredient;Strength;Unit of Measure');
      const ingredientGrpList = this.ingredients.controls;
      for (let i = 0; i < ingredientGrpList.length; i++) {
        const displayString = `${ingredientGrpList[i].value.ingredient};${ingredientGrpList[i].value.strength};${ingredientGrpList[i].value.unitOfMeasure}`;
        displayList.push(displayString);
      }
    }
    else if (displayHeading === 'Route(s) of Administration') {
      const routeList = this.routes.controls;
      for (let i = 0; i < routeList.length; i++) {
        const displayString = routeList[i].value;
        displayList.push(displayString);
      }
    }
    else if (displayHeading === 'ATC Code(s)') {
      displayList.push('ATC Code;Ingredient;Strength');
      const atcCodeGrpList = this.atcCodes.controls;
      for (let i = 0; i < atcCodeGrpList.length; i++) {
        const displayString = `${atcCodeGrpList[i].value.atcCode};${atcCodeGrpList[i].value.ingredient};${atcCodeGrpList[i].value.level}`;
        displayList.push(displayString);
      }
    }

    const dialogRef = this.dialog.open(GenericListDialogComponent, {
      width: '40vw',
      data: {list: displayList, heading: displayHeading}
    });
  }

  openAtcDialog() {
    const dialogRef = this.dialog.open(AddAtcDialogComponent, {
      width: '40vw'
    });
  }

  openIngredientDialog() {
    const isDialog = true;
    const dialogRef = this.dialog.open(AddIngredientViewComponent, {
      width: '80vw',
      data: isDialog
    });
  }

  ingredientNext() {
    let canContinue = true;

    const ingredientGrpList = this.ingredients.controls;
    for (let i = 0; i < ingredientGrpList.length; i++) {
      if (ingredientGrpList[i].value.strength > 1000) {
        canContinue = false;

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '40vw',
          data:
            'The ingredient strength of one or more ingredients is greater than 1000. Are you sre you wish to proceed?'
        });

        dialogRef.afterClosed().subscribe((result) => {
          const isConfirmed = result;

          if (isConfirmed) {
            this.masterDrugStepper.next();
          }
          else {
            ingredientGrpList[i].value.strength.reset();
          }
        });

        break;
      }
    }
    if (canContinue) {
      this.masterDrugStepper.next();
    }
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo != null) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo != null ? helpInfo.inputInfo : '';
    }
    return message;
  }
}
